<template>
    <pm-app-component hide-sidebar>

        <template slot="mobile-toolbar">
            <pm-application-bar simple>
                {{ $t('menu.subscriptions') }}
            </pm-application-bar>
        </template>

        <div v-if="!isRestoringPurchases">
            <div style="display: block; padding: 0;">
                <pm-app-loading-content-indicator v-if="isLoading" style="height: 250px; min-height: Calc(100vh - 140px)!important;" />
                <pm-app-loading-content-indicator v-if="processing" style="height: 250px; min-height: Calc(100vh - 140px)!important;" text="Processing" />

                <div v-if="!isLoading && !processing">
                    <div style="padding: 30vh 30px 0 30px; font-size: 16px; text-align: center" v-if="Object.values(items).length === 0">
                        <h3 class="pink--text" style="font-weight: 600; font-size: 20px;">
                            {{$t('iap.could-not-load-addons')}}
                        </h3>
                        <br/>
                        {{$t('iap.issue-in-store', { store: $isIOS() ? 'AppStore' : 'Google Play' })}}
                        <br/><br/>
                        <b style="font-weight: 600">{{$t('iap.check-back-later')}}</b>
                    </div>
                    <pm-addon-item
                        v-for="item in getSortedItems()"
                        v-if="item.show_in_addons"
                        :key="item.id"
                        :item="item"
                        :processing="processing"
                        @subscribe="subscribe(item)"
                        @unsubscribe="unsubscribe(item)"
                        @restorePurchase="restorePurchase()"
                    />
                </div>

                <div style="padding: 20px" v-if="Object.values(items).length">
                    <div style="line-height: 1.3; font-size: 13px;">
                        {{ $t('payment.cancel_subscription') }}
                        {{ $t('subscriptions.subscription_description') }}
                        <span v-if="$isIOS()">{{ $t('subscriptions.cancel_itunes') }}</span>
                        <span v-else>{{ $t('subscriptions.cancel_play') }}</span>
                        <br>
                        <br>

                        <div>
                            <pm-privacy-links />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <pm-app-loading-content-indicator v-else />
        <pm-promo-form />
    </pm-app-component>
</template>

<script>
import PmAddonItem from "./addon-item";
import PmSimpleComponentLayout from "@/components/core/pm-simple-component-layout";
import PmPrivacyLinks from "./privacy-links";
import PmPromoForm from "./promo-form";
import ToolbarMixin from "../../extensions/mixins/mixin-toolbar";

import { IAPgetOfferings } from "@/utils/iap";

export default {
    name: "PmSubscriptions",
    mixins: [
        ToolbarMixin,
    ],
    components: {
        PmSimpleComponentLayout,
        PmAddonItem,
        PmPrivacyLinks,
        PmPromoForm,
    },
    data: () => ({
        isLoading: !window.IAP.status.includes('offeringsLoaded'),
        processing: false,
        isRestoringPurchases: false,
        items: {},
    }),
    toolbar() {
        const items = [];


            items.push({
                mdi: "mdiWalletGiftcard",
                text: app.$t('iap.redeem-promo-code-menu'),
                callback: () => {
                    this.$bus.$emit('promo-code-form:show');
                },
            });

            items.push({ placeholder: true });

            items.push({ placeholder: true });

            items.push({
                back: true,
                callback: () => {
                    this.$router.push("/");
                },
            });


        return ([items]);
    },
    created() {
        if(this.isLoading) {
            this.registerBusEvent("flutter:getOfferings", () => {
                this.$nextTick(() => {
                    this.isLoading = false;
                    this.updateItems();
                });
            });
        }
        this.registerBusEvent("flutter:paymentStateChanged", this.handlePaymentStateChanged); // @TODO: remove if updated in flutter & in users
        this.registerBusEvent("flutter:paymentError", this.handlePaymentResponse); // @TODO: remove if updated in flutter & in users
        this.registerBusEvent("flutter:paymentStateError", this.handlePaymentResponse); // @TODO: remove if updated in flutter & in users
        this.registerBusEvent("flutter:paymentRestoreError", this.handleRestoreFailed);
        this.registerBusEvent("flutter:onOfferingsUpdated", this.updateItems);
        this.registerBusEvent("flutter:paymentRestoreSucceed", this.handleRestoreSucceed);
        this.registerBusEvent("flutter:paymentRestoreFailed", this.handleRestoreFailed);
        this.registerBusEvent('flutter:paymentSucceed', this.handlePaymentSucceed);
        this.registerBusEvent('flutter:paymentFailed', this.handlePaymentFailed);
    },
    mounted() {
        this.updateItems();
    },
    activated() {
        this.updateItems();
    },
    methods: {
        getSortedItems() {
            const items = Object.values(this.items);
            return items.sort((a,b) => {
                return a.ordering < b.ordering ? -1 : a.ordering < b.ordering ? 1 : 0;
            });
        },
        updateItems() {
            this.items = this.getItems();
        },

        getItems() {
            try {
                const prods = window.IAP.products;
                if (!prods) return {};
                return prods;
            } catch(error) {
                captureException(error);
                return {};
            }
        },

        subscribe(item) {
            /*if (item.price === 'FREE') {
                localStorage.setItem(item.id, 'true');
                this.items = this.getItems();
                this.$forceUpdate();
                return;
            }*/

            this.processing = true;
            window.IAP.subscribe(item.id);
        },

        unsubscribe(item) {
            /*if (item.price === 'FREE') {
                localStorage.setItem(item.id, 'false');
                this.items = this.getItems();
                this.$forceUpdate();
                return;
            }*/

            // this.processing = true; ????
            window.IAP.unsubscribe(item.id);
        },

        restorePurchase() {
            window.IAP.restore();
            this.isRestoringPurchases = true;
        },

        handleRestoreSucceed(data) {
            // @TODO: use data instead getOfferings
            IAPgetOfferings(true);
            this.$bus.$emit('app.showSnackbar', {
                text: 'Restoring purchases completed',
            });
            this.isRestoringPurchases = false;
            this.isLoading = false;
            this.processing = false;
        },

        handleRestoreFailed() {
            this.$bus.$emit("app.showSnackbar", {text: this.$t("subscriptions.restore_error")});
            this.isRestoringPurchases = false;
            this.isLoading = false;
            this.processing = false;
        },

        handlePaymentFailed(data) {
            this.isLoading = false;
            this.processing = false;
            if (this.$router.currentRoute.name === 'addons') this.$bus.$emit('app.showSnackbar', {text: this.$t('subscriptions.payment_error')});
        },

        handlePaymentSucceed(data) {
            this.isLoading = false;
            this.processing = false;
            this.$nextTick(() => {
                this.updateItems();
                this.$forceUpdate(); // @TODO still required?
            });
        },

        handlePaymentStateChanged() {
            // @TODO: remove after removed from flutter and users updated
            this.isLoading = false;
            this.processing = false;
            this.$nextTick(() => {
                this.updateItems();
                this.$forceUpdate(); // @TODO still required?
            });
        },

        handlePaymentResponse(data) {
            if (data.text === 'Finished') this.handlePaymentSucceed();
            else this.handlePaymentFailed();
        },
    },
};
</script>

<style scoped lang="scss">
    .main-wrapper {
        overflow: hidden;
        box-shadow: 0 8px 15px rgba(0,0,0,.08);
        background: #fff;
        height: auto;
        width: 100%;
        min-height: calc(100vh - 160px);
        display: flex;
        justify-content: center;
    }
</style>
